import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  search: {
    marginTop: 25,
    marginLeft: 10
  }
}))
